import { Navigate, useParams } from "react-router-dom";

import { db } from "astrid-firebase";
import useDocumentData from "astrid-firestore/src/hooks/useDocumentData";

import NotFound from "../../../components/NotFound";

export default function ArticleRedirect() {
	const { id } = useParams();

	const [article, loading] = useDocumentData(db.collection("articles").doc(id));

	if (loading) {
		return null;
	}

	if (article?.work?.id) {
		return <Navigate to={`/admin/works/${article.work.id}`} replace />;
	}

	return <NotFound />;
}
